module.exports = __webpack_public_path__ + "static/images/TitleLogo.45feb9de.png";